// extracted by mini-css-extract-plugin
export default {"spinner":"input-with-loading_spinner__b8a22","padding":"input-with-loading_padding__ddee5"};